<template>
  <div>
    <div class="m-5 px-5" >
      <table class="table table-hover">
          <thead>
            <tr>
              <th>Num</th>
              <th>Worker ID</th>
              <th>Create Time</th>
              <th>Condition</th>
              <th>Completion Code</th>
              <th>Finish?</th>
              <th>Bugs?</th>
              <th>User Type</th>
              <th>Edit</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users" :key="index">
              <td>{{ index + 1 }}</td>
              <td><router-link :to="{ name: 'UserData', params: { id: user.userID }}">
                  {{ user.workerID }}</router-link></td>
              <td>{{ user.time_series_condition }}</td>
              <td>{{ user.create_time }}</td>
              <td>{{ user.completion_code }}</td>
              <td>
                <span v-if="user.account_progress === 'Finish'">Yes</span>
                <span v-else>No</span>
              </td>
              <td>
                <span v-if="user.if_bugs == '1'"><b>Yes</b></span>
                <span v-else>No</span>
              </td>
              <td>
              <div>{{dropReason[user.drop]}}</div>
              </td>
              <th><button
                    type="button"
                    class="btn btn-warning btn-sm m-2"
                    @click="showEditUserModal(user)"
                  >Edit
                </button></th>
            </tr>
          </tbody>
        </table>
    </div>
  <b-modal ref="editModal" hide-footer title="Edit User">
    <div class="d-block text-center">
      <h3>User Info</h3>
      <p>userID: {{editForm.userID}}</p>
      <p>taskID: {{editForm.taskID}}</p>
      <p>workerID: {{editForm.workerID}}</p>
      <p>verify: {{editForm.verify}}</p>
      <p>drop: {{editForm.drop}}</p>
      <b-row>
        <b-col sm="3"><label>Drop?</label></b-col>
        <b-col sm="9"><b-form-select v-model="editForm.changeDrop" class="mb-3">
          <b-form-select-option value=0>Valid Data</b-form-select-option>
          <b-form-select-option value=1>Admin/RA</b-form-select-option>
          <b-form-select-option value=2>First 20/100</b-form-select-option>
          <b-form-select-option value=3>Programming Error</b-form-select-option>
          <b-form-select-option value=4>Never Finish</b-form-select-option>
        </b-form-select></b-col>
      </b-row>
    </div>
    <b-button class="mt-3" variant="outline-danger" block @click="submitDrop">Update Drop</b-button>
  </b-modal>
  </div>
</template>
<style scoped>
.modal-backdrop {
  display: none;
}
</style>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      tasks: [],
      users: null,
      editForm: {
        userID: '',
        taskID: '',
        workerID: '',
        verify: '',
        drop: null,
        changeDrop: null,
      },
      singleUser: {},
      dropReason: ['Valid Data', 'Admin/RA', 'First 20/100', 'Programming Error', 'Never Finish'],
    };
  },
  methods: {
    getData() {
      const path = `${this.$hostname}/get-users`;
      axios
        .get(path)
        .then((res) => {
          console.log(res.data.Auth);
          if (res.data.Auth !== 'admin') {
            this.$router.push({ name: 'Login' });
          } else {
            this.users = res.data.users;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    getRow(record, index) {
      console.log(index);
      console.log(record);
    },
    verifyUser(user) {
      const payload = {
        verify: 1,
        drop: 'noChange',
        taskID: user.taskID,
      };
      this.submitVerify(payload, user.userID);
    },
    unVerifyUser(user) {
      const payload = {
        verify: 0,
        drop: 'noChange',
        taskID: this.editForm.taskID,
      };
      this.submitVerify(payload, user.userID);
    },
    submitDrop() {
      const payload = {
        verify: 'noChange',
        drop: this.editForm.changeDrop,
        taskID: this.editForm.taskID,
      };
      this.submitVerify(payload, this.editForm.userID);
    },
    submitVerify(payload, userID) {
      const path = `${this.$hostname}/verify-user/${userID}`;
      axios
        .put(path, payload)
        .then(() => {
          this.getData();
          this.$refs.editModal.hide();
          this.initialEditForm();
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
          this.getData();
        });
    },
    showEditUserModal(user) {
      this.editForm.userID = user.userID;
      this.editForm.taskID = user.taskID;
      this.editForm.workerID = user.worker_ID;
      this.editForm.verify = user.is_verify;
      this.editForm.drop = user.drop;
      this.editForm.changeDrop = user.drop;
      this.$refs.editModal.show();
    },
    initialEditForm() {
      this.editForm = {
        userID: '',
        taskID: '',
        workerID: '',
        verify: '',
        drop: null,
        changeDrop: null,
      };
    },
  },
  created() {
    this.getData();
  },
};
</script>
